module.exports = __webpack_public_path__ + "media/images/img-hobby-8-3a2d46b1.jpg";